export default __webpack_public_path__ + "static/media/trackActivity.a6adb184.png";